<script>
    import { onMount, onDestroy } from "svelte";
    import * as api from "../utiles/api";
    import * as store from "../stores/store";
    import { push } from "svelte-spa-router";
    import Header from "../components/Header.svelte";
    import * as common from "../utiles/common.util";
    import { Camera, CameraResultType, CameraSource } from "@capacitor/camera";

    export let params;

    let rcept_NO = "";
    let charger_EMPL_NM = "";
    let rcept_DE = "";
    let bcnc_NM = "";
    let bcnc_ADDR = "";
    let bcnc_TELNO = "";
    let item_NM = "";
    let asgn_EMPL_NM = "";
    let shipmnt_DE = "";
    let pay_SE_NM = "";
    let rcept_SN = "";
    let rcept_CN = "";
    let sttus = "";
    let sttus_nm = "";
    let PHOTO_SE = "1";
    let RM = "";
    let bcnc_CODE = "";
    let mobile_CONF_AT = "";

    let AS_INPUT_ITEM_CODE = "";
    let AS_BTRPS = 0;
    let STARTDT = "";
    let COMPTDT = "";
    let visit_PRARNDT = "";

    let totalUntpc = 0;
    let item_list = [];

    let resrve_RESN = "";

    let showPartsDetail = false;

    $: parsedParts = AS_INPUT_ITEM_CODE
        ? AS_INPUT_ITEM_CODE.split(",").map((s) => s.trim()).filter(Boolean)
        : [];

    onMount(() => {
        window.scrollTo(0, 0);
        getData();
    });

    async function getData() {
        const response = await api.get(
            `/as/${params.rcept_NO}?RCEPT_SN=${params.rcept_SN}`,
        );

        if (response != null) {
            const data = response.data;

            item_list = data.item_list;

            totalUntpc = item_list.reduce(
                (sum, item) =>
                    sum +
                    (parseFloat(item.untpc) || 0) * (parseInt(item.qy) || 0),
                0,
            );

            rcept_NO = data.rcept_NO?.trim() || "";
            charger_EMPL_NM = data.charger_EMPL_NM?.trim() || "";
            rcept_DE = data.rcept_DE?.trim() || "";
            bcnc_NM = data.bcnc_NM?.trim() || "";
            bcnc_CODE = data.bcnc_CODE?.trim() || "";
            bcnc_ADDR = data.bcnc_ADDR?.trim() || "";
            bcnc_TELNO = data.bcnc_TELNO?.trim() || "";
            item_NM = data.item_NM?.trim() || "";
            asgn_EMPL_NM = data.asgn_EMPL_NM?.trim() || "";
            shipmnt_DE = data.shipmnt_DE?.trim() || "";
            pay_SE_NM = data.pay_SE_NM?.trim() || "";
            rcept_SN = data.rcept_SN?.trim() || "";
            rcept_CN = data.rcept_CN?.trim() || "";
            RM = data.rm?.trim() || "";
            sttus = data.sttus;
            mobile_CONF_AT = data.mobile_CONF_AT;
            AS_INPUT_ITEM_CODE = data.as_INPUT_ITEM_CODE?.trim() || "";
            AS_BTRPS = common.formatCurrency(data.as_BTRPS || 0);
            STARTDT = data.startdt?.split(" ")[0] ?? "";
            COMPTDT = data.comptdt?.split(" ")[0] ?? "";
            visit_PRARNDT = data.visit_PRARNDT
                ? data.visit_PRARNDT.split(" ")[0]
                : "";
            resrve_RESN = data.resrve_RESN?.trim() || "";

            if (sttus == "I") {
                sttus_nm = "M";
            } else if (sttus == "M") {
                sttus_nm = "T";
            } else if (sttus == "H") {
                sttus_nm = "T";
            } else if (sttus == "T") {
                PHOTO_SE = "2";
                sttus_nm = "D";
            }
        }
    }

    async function saveClick() {
        let resrve_resn = ""; // 보류 사유 변수

        // 상태가 'H'(보류)일 경우 사유 입력 받기
        if (sttus_nm === "H") {
            resrve_resn = prompt("보류 사유를 입력해 주세요.");

            // 사용자가 취소를 누르거나 빈 값을 입력했을 때 처리
            if (resrve_resn === null) return; // 취소 시 중단
            if (resrve_resn.trim() === "") {
                alert("보류 사유는 필수 입력 항목입니다.");
                return;
            }
        }

        const formData = {
            RCEPT_NO: rcept_NO,
            RCEPT_SN: rcept_SN,
            STTUS: sttus_nm,
            BCNC_NM: bcnc_NM,
            RESRVE_RESN: resrve_resn,
        };

        const response = await api.post("/as/put", formData);

        if (response != null) {
            if (Capacitor.isNativePlatform()) {
            }

            if (sttus_nm == "M") {
                alert("A/S 접수 확인되었습니다.");
            } else if (sttus_nm == "H") {
                alert("A/S 보류 되었습니다.");
            }

            location.reload();
        } else {
            alert(response.msg);
        }
    }

    async function saveVisit_PRARNDT() {
        const formData = {
            RCEPT_NO: rcept_NO,
            RCEPT_SN: rcept_SN,
            VISIT_PRARNDT: visit_PRARNDT,
        };

        const response = await api.post("/as/put/visit_PRARNDT", formData);

        if (response != null) {
            alert("방문예정일 설정 완료");

            getData();
        } else {
            alert(response.msg);
        }
    }

    function call(number) {
        if (number != "") {
            window.location.href = `tel:${number}`;
        }
    }

    function getHistory() {
        push(
            `/AsHistoryList/${bcnc_CODE}/${params.rcept_NO}_${params.rcept_SN}`,
        );
    }

    function goBack() {
        push("/AsList");
    }

    // 페이지가 로드될 때 goBack 등록
    store.currentGoBack.set(goBack);

    // 페이지 벗어나면 해제
    onDestroy(() => {
        store.currentGoBack.set(null);
    });
</script>

<Header {goBack} />

<!-- svelte-ignore a11y-click-events-have-key-events -->
<section
    class="main inner main-gray"
    style="width: 100%; position: relative; overflow-y: auto; {sttus === 'T'
        ? ''
        : 'height: 100vh; padding-bottom: 220px;'}"
>
    <div class="mobile">
        <div style="background: #FFF;">
            <div
                class="cmn-title-left gray-width"
                style="padding-top: 20px; padding-bottom: 15px;"
            >
                <p>상세 내역</p>
            </div>

            <div class="gray-width" style="padding-bottom: 10px;">
                <div class="cart-order-list" style="padding: 0;">
                    <ul>
                        <li style="border-bottom: none;">
                            <div class="list-in">
                                <p class="list-title">접수일자</p>
                            </div>
                            <div class="list-in list-in_">
                                <p>{rcept_DE.replaceAll("-", ".")}</p>
                            </div>

                            {#if sttus === "T"}
                                <div class="list-in">
                                    <p class="list-title">출장일자</p>
                                </div>
                                <div class="list-in list-in_">
                                    <p>{STARTDT.replaceAll("-", ".")}</p>
                                </div>

                                <div class="list-in">
                                    <p class="list-title">완료일자</p>
                                </div>
                                <div class="list-in list-in_">
                                    <p>{COMPTDT.replaceAll("-", ".")}</p>
                                </div>
                            {/if}

                            <div class="list-in">
                                <p class="list-title">거래처명</p>
                            </div>
                            <div class="list-in list-in_">
                                <p
                                    on:click={() => {
                                        getHistory();
                                    }}
                                >
                                    {bcnc_NM}
                                </p>
                            </div>

                            <div class="list-in">
                                <p class="list-title">거래처 주소</p>
                            </div>

                            <div class="list-in list-in_">
                                <p>{bcnc_ADDR}</p>
                            </div>

                            <div class="list-in">
                                <p class="list-title">거래처 연락처</p>
                            </div>
                            <div class="list-in list-in_">
                                <p
                                    on:click={() => {
                                        call(bcnc_TELNO);
                                    }}
                                >
                                    {bcnc_TELNO}
                                </p>
                            </div>

                            <div class="list-in">
                                <p class="list-title">모델명</p>
                            </div>
                            <div class="list-in list-in_">
                                <p>{item_NM}</p>
                            </div>

                            <div class="list-in">
                                <p class="list-title">접수자</p>
                            </div>
                            <div class="list-in list-in_">
                                <p>{charger_EMPL_NM}</p>
                            </div>

                            <div class="list-in">
                                <p class="list-title">처리 담당</p>
                            </div>
                            <div class="list-in list-in_">
                                <p>{asgn_EMPL_NM}</p>
                            </div>

                            <div class="list-in">
                                <p class="list-title">납품일자</p>
                            </div>
                            <div class="list-in list-in_">
                                <p>{shipmnt_DE}</p>
                            </div>

                            {#if sttus != "I"}
                                <div class="list-in">
                                    <p class="list-title">방문예정일</p>
                                </div>

                                <div
                                    class="list-in list-in_"
                                    style="display: flex; align-items: center; gap: 10px;"
                                >
                                    <input
                                        bind:value={visit_PRARNDT}
                                        type="date"
                                        style="flex: 1; height: 40px; font-size: 18px; color: #000; background-color: #fff; border: 1px solid #ccc; border-radius: 4px; padding:3px;"
                                    />
                                    <button
                                        on:click={saveVisit_PRARNDT}
                                        style="width: 70px; height: 48px; background-color: #4A5568; color: white; border-radius: 4px; font-size: 14px; border: none; padding:3px;"
                                    >
                                        저장
                                    </button>
                                </div>
                            {/if}

                            {#if sttus == "H"}
                                <div class="list-in">
                                    <p class="list-title">보류 사유</p>
                                </div>
                                <div class="list-in list-in_">
                                    <p>{resrve_RESN}</p>
                                </div>
                            {/if}

                            <div class="list-in">
                                <p class="list-title">유상무상</p>
                            </div>
                            <div class="list-in list-in_">
                                <p>{pay_SE_NM}</p>
                            </div>

                            {#if sttus === "T"}
                                <div class="list-in">
                                    <p class="list-title">사용부품</p>
                                </div>
                                <div class="list-in list-in_" style="display: flex; flex-direction: column; width: 100%;">
                                    {#if parsedParts.length >= 2}
                                        <!-- svelte-ignore a11y-click-events-have-key-events -->
                                        <div
                                            on:click={() => (showPartsDetail = !showPartsDetail)}
                                            style="display: flex; justify-content: space-between; align-items: center; cursor: pointer; width: 100%;"
                                        >
                                            <p style="margin: 0; font-weight: 600; color: #1E293B;">
                                                {parsedParts[0]} 외 {parsedParts.length - 1}개
                                            </p>
                                            <span style="font-size: 12px; color: #2563EB; font-weight: 700;">
                                                {showPartsDetail ? "접기 ▲" : "상세보기 ▼"}
                                            </span>
                                        </div>
                                        {#if showPartsDetail}
                                            <div style="background: #F8FAFC; border: 1px solid #E2E8F0; border-radius: 6px; padding: 8px 10px; margin-top: 6px; width: 100%; box-sizing: border-box;">
                                                {#each parsedParts as part}
                                                    <p style="margin: 3px 0; font-size: 13px; color: #334155;">• {part}</p>
                                                {/each}
                                            </div>
                                        {/if}
                                    {:else}
                                        <p>{AS_INPUT_ITEM_CODE || "없음"}</p>
                                    {/if}
                                </div>

                                <div class="list-in">
                                    <p class="list-title">출장비</p>
                                </div>
                                <div class="list-in list-in_">
                                    <p>{AS_BTRPS} 원</p>
                                </div>
                            {/if}

                            <div class="list-in">
                                <p class="list-title">접수 내용</p>
                            </div>
                            <div class="list-in">
                                <!-- prettier-ignore -->
                                <textarea
                                    style="width:100%; height:150px"
                                    readonly
                                >{rcept_CN}</textarea>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            {#if sttus === "I"}
                <div class="cmn-btn cmn-btn-btm">
                    <button on:click={saveClick}>접수 확인</button>
                </div>
            {:else if sttus === "M"}
                <div class="cmn-btn cmn-btn-btm" style="margin-bottom:120px">
                    <button
                        on:click={() => {
                            sttus_nm = "H";
                            saveClick();
                        }}
                    >
                        처리 보류
                    </button>
                </div>

                <div class="cmn-btn cmn-btn-btm" style="margin-bottom:65px">
                    <button
                        on:click={() => {
                            push(
                                `/AsForm/${params.rcept_NO}/${params.rcept_SN}/${PHOTO_SE}`,
                            );
                        }}
                    >
                        처리 전 이미지 업로드
                    </button>
                </div>

                <div class="cmn-btn cmn-btn-btm">
                    <button
                        on:click={() => {
                            push(
                                `/AsRM/${rcept_NO}/${rcept_SN}/${sttus_nm}/${encodeURIComponent(bcnc_NM)}`,
                            );
                        }}
                    >
                        처리 완료
                    </button>
                </div>
            {:else if sttus === "H"}
                <div class="cmn-btn cmn-btn-btm" style="margin-bottom:65px">
                    <button
                        on:click={() => {
                            push(
                                `/AsForm/${params.rcept_NO}/${params.rcept_SN}/${PHOTO_SE}`,
                            );
                        }}
                    >
                        처리 전 이미지 업로드
                    </button>
                </div>

                <div class="cmn-btn cmn-btn-btm">
                    <button
                        on:click={() => {
                            push(
                                `/AsRM/${rcept_NO}/${rcept_SN}/${sttus_nm}/${encodeURIComponent(bcnc_NM)}`,
                            );
                        }}
                    >
                        처리 완료
                    </button>
                </div>
            {:else if sttus === "T"}
                <!-- <div class="cmn-btn cmn-btn-btm" style="margin-bottom:65px">
                    <button
                        on:click={() => {
                            push(
                                `/AsForm/${params.rcept_NO}/${params.rcept_SN}/${PHOTO_SE}`
                            );
                        }}
                    >
                        처리 후 이미지 업로드
                    </button>
                </div>

                <div class="cmn-btn cmn-btn-btm">
                    <button on:click={saveClick}>사용 부품 등록</button>
                </div> -->
            {/if}
        </div>
    </div>
</section>

<!-- svelte-ignore a11y-click-events-have-key-events -->
{#if sttus === "T"}
    <section class="inner main-gray" style="width: 100%; position: relative;">
        <div class="mobile">
            <div style=" background: #FFF;">
                <div class="gray-width" style="padding-bottom: 10px;">
                    <div class="cart-order-list" style="padding: 0;">
                        <ul>
                            <li style="border-bottom: none;">
                                <div class="list-in">
                                    <p class="list-title" style="width:140px">
                                        작업 전 이미지
                                    </p>
                                    <p
                                        on:click={() => {
                                            push(
                                                `/AsForm/${params.rcept_NO}/${params.rcept_SN}/1`,
                                            );
                                        }}
                                    >
                                        상세
                                    </p>
                                </div>

                                <div class="list-in">
                                    <p class="list-title" style="width:140px">
                                        작업 후 이미지
                                    </p>
                                    <p
                                        on:click={() => {
                                            push(
                                                `/AsForm/${params.rcept_NO}/${params.rcept_SN}/2`,
                                            );
                                        }}
                                    >
                                        상세
                                    </p>
                                </div>

                                <div class="list-in">
                                    <p class="list-title" style="width:90px">
                                        작업내용
                                    </p>
                                    <p
                                        on:click={() => {
                                            push(
                                                `/AsRM/${rcept_NO}/${rcept_SN}/T/${encodeURIComponent(bcnc_NM)}`,
                                            );
                                        }}
                                    >
                                        상세
                                    </p>
                                </div>

                                <div class="list-in">
                                    <!-- prettier-ignore -->
                                    <textarea
                                        style="width:100%; height:100px"
                                        readonly
                                    >{RM}</textarea>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
{/if}

<style>
    p {
        white-space: unset;
    }

    .list-in_ {
        border-bottom: 1px solid;
    }
</style>
